<template>
    <div>
        <div v-if="success">
            <span class="title title--sl popup__title">{{ $lang('shortPageLimit.title') }}</span>
            <span class="popup__header-description">{{ $lang('shortPageLimit.descr') }}</span>
        </div>
        <div v-else>
            <div class="popup__header popup__header--no-bottom">
                <span class="title title--sl popup__title">{{ $lang('shortPageLimit.title2') }}</span>
                <span class="popup__header-description">{{ $lang('shortPageLimit.descr2') }}</span>
            </div>
            <div class="popup__content">
                <div class="form__item">
                    <button class="btn btn--middle btn--main-bg" @click="submit">{{ $lang('shortPageLimit.button') }}</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "ShortPageLimit",
    data() {
        return {
            success: false
        }
    },
    methods: {
        submit: function() {
            window.location.href = window.laravel.prefix + '/contacts';
        }
    }
}
</script>
